import { routes, useMakeUrl } from "./urls";

export type ChatWorkflowTarget = {
  id: string;
  spaceId: string;
  branchId?: string | null;
};

export function useChatWorkflowUrl() {
  const makeUrl = useMakeUrl();
  return (chatId: string, workflow: ChatWorkflowTarget) =>
    makeUrl(
      routes.space.workflow,
      {
        spaceId: workflow.spaceId,
        workflowId: workflow.id,
        chatId,
        ...(workflow.branchId && { branchId: workflow.branchId }),
      },
      { inheritParams: false }
    );
}
